import styled from 'styled-components'

import { breakpoint } from 'style/theme'

export default styled.div`
  text-align: center;

  .service-content {
    margin-top: 30px;
    display: grid;
    row-gap: 40px;
    column-gap: 30px;
    grid-template-columns: repeat(5, 1fr);
  }

  @media (max-width: ${breakpoint.lg}) {
    .service-content {
      row-gap: 28px;
      column-gap: 18px;
      grid-template-columns: repeat(3, 1fr);
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .service-content {
      row-gap: 18px;
      column-gap: 12px;
      grid-template-columns: repeat(2, 1fr);
    }
  }
`
